import { useEffect } from "react";

// Mobile keyboards resize the visual viewport without resizing 100dvh on iOS.
// Keep the composer and dialogs inside it, while preserving pinch-to-zoom.
export function useMobileViewport() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const mobile = window.matchMedia("(max-width: 767px)");
    const style = document.documentElement.style;
    const clear = () => {
      style.removeProperty("--app-viewport-height");
      style.removeProperty("--app-viewport-top");
    };
    const update = () => {
      if (!mobile.matches) return clear();
      if (viewport.scale !== 1) return;
      style.setProperty("--app-viewport-height", `${viewport.height}px`);
      style.setProperty("--app-viewport-top", `${viewport.offsetTop}px`);
    };
    update();
    viewport.addEventListener("resize", update);
    viewport.addEventListener("scroll", update);
    mobile.addEventListener("change", update);
    return () => {
      viewport.removeEventListener("resize", update);
      viewport.removeEventListener("scroll", update);
      mobile.removeEventListener("change", update);
      clear();
    };
  }, []);
}
